   (function ($) {
    $(function () {
      const nav = $('.site-navigation ');
      const promo =  $('.header-promo');
      let promoHeight = $('.header-promo').outerHeight();
      const close = $('.header-promo__close');
      const distance = nav.offset().top;
    
      if(promoHeight > 0){
        $(window).on('scroll',function(){
            if(($(this).scrollTop() + promoHeight) >= distance){
              nav.css('top',promoHeight) ;
            }else{
              nav.css('top',0) ;
            }
          });
      }

      close.on('click',function(){
          promo.slideToggle();
          promoHeight = 0;
      });

    });
})(jQuery);